import { useDispatch } from 'react-redux';
import { getActaPublicaFile } from '../../../../../appStore/actas';
import LinkBtn from '../../../../CompUtils/LinkBtn';

export const ActaPublicaFila = (props) => {
  const { titulo, fechaCreacion, idActaConcurso } = props;
  const dispatch = useDispatch();
  return (
    <tr>
      <td>{titulo}</td>
      <td>
        <LinkBtn transparent onClick={() => dispatch(getActaPublicaFile({ idActaConcurso }))}>
          <i className="fa fa-lg fa-file-text-o text-muted" />
        </LinkBtn>
      </td>
    </tr>
  );
};
